import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { css, html } from 'react-strict-dom';
import { Color, Style } from 'src/constants';

import { Text } from '../../../components';

/**
 * The breadcrumb back to the Projects screen, which every Service Order
 * screen is reached from.
 */
export default function BackToProjects() {
  return (
    <Link to="/projects" {...css.props(styles.link)}>
      <html.div style={[Style.row, Style.alignCenter, styles.wrap]}>
        <ArrowLeft size={14} weight="regular" color={Color.neutral60} />
        <Text typeface="caption.medium" color="neutral60">
          Projects
        </Text>
      </html.div>
    </Link>
  );
}

const styles = css.create({
  link: {
    textDecoration: 'none',
    alignSelf: 'flex-start',
  },
  wrap: {
    gap: 6,
  },
});
